'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _TimePicker = require('./TimePicker');

var _TimePicker2 = _interopRequireDefault(_TimePicker);

exports['default'] = _TimePicker2['default'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-time-picker/lib/index.js
 ** module id = 1438
 ** module chunks = 0
 **/